import { IconButton, useDisclosure } from '@chakra-ui/react';
import { FiUsers } from 'react-icons/fi';
import { useAppSelector } from '../../../core/hooks/storeHooks';
import UsersListDrawer from '../drawers/usersList/UsersListDrawer';

const UsersDrawer = () => {
  const userId = useAppSelector((state) => state.auth.user.id);
  const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <>
      <IconButton
        ml={2}
        size="sm"
        borderRadius="50%"
        onClick={onOpen}
        icon={<FiUsers />}
        aria-label="Open Users List"
      />
      <UsersListDrawer  activeUserId={userId} isOpen={isOpen} onClose={onClose} />
    </>
  );
};

export default UsersDrawer;
